// extracted by mini-css-extract-plugin
export default {"heroSection":"ServicesView_heroSection__zlr4+","services":"ServicesView_services__alaNr"};